import { Filter } from '@elderbyte/ngx-starter'

export class ProdOrderTransitFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly SOURCE_FACILITY_KEY = 'sourceFacility'
  public static readonly TARGET_FACILITY_KEY = 'targetFacility'
  public static readonly PROD_ORDER_IDS_KEY = 'prodOrderIds'

  private _sourceFacility: string
  private _targetFacility: string
  private _prodOrderIds: string[]

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static sourceFacility(sourceFacility: string): Filter {
    return this.start().sourceFacility(sourceFacility).build()[0]
  }

  public static targetFacility(targetFacility: string): Filter {
    return this.start().targetFacility(targetFacility).build()[0]
  }

  public static prodOrders(...prodOrders: string[]): Filter {
    return this.start()
      .prodOrders(...prodOrders)
      .build()[0]
  }

  public static start(): ProdOrderTransitFilterBuilder {
    return new ProdOrderTransitFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public sourceFacility(sourceFacility: string): ProdOrderTransitFilterBuilder {
    this._sourceFacility = sourceFacility
    return this
  }

  public targetFacility(targetFacility: string): ProdOrderTransitFilterBuilder {
    this._targetFacility = targetFacility
    return this
  }

  public prodOrders(...prodOrders: string[]): ProdOrderTransitFilterBuilder {
    this._prodOrderIds = prodOrders
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._sourceFacility) {
      filters.push(
        new Filter(ProdOrderTransitFilterBuilder.SOURCE_FACILITY_KEY, this._sourceFacility)
      )
    }

    if (this._targetFacility) {
      filters.push(
        new Filter(ProdOrderTransitFilterBuilder.TARGET_FACILITY_KEY, this._targetFacility)
      )
    }

    if (this._prodOrderIds) {
      filters.push(new Filter(ProdOrderTransitFilterBuilder.PROD_ORDER_IDS_KEY, this._prodOrderIds))
    }

    return filters
  }
}
